<script>
  import VideoAnalyticOverview from './VideoAnalyticOverview.svelte';
  import VideoEngagementGraph from './VideoEngagementGraph.svelte';
  import { M } from '../../external';

  export let id;
  export let type; //VIDEO, FOLDER or USER

  let isLoading = false;

  let show = 'OVERVIEW';

  let chartData = {
    labels: [],
    playTime: {
      data: [],
      total: 0
    },
    totalViews: {
      data: [],
      total: 0
    },
    uniqueViews: {
      data: [],
      total: 0
    },
    engagement: {
      data: [],
      total: 0
    }
  };

  let setActiveTab = (tabName) => {
    if (!isLoading) {
      show = tabName;
    }
  };
</script>

<div>
  <div class="padded-crm-wrapper-outer" style="max-width: 1000px;">
    {#if type === 'video'}
      <ul class="upper-navigation upper-navigation-full mb-15 f-left col20">
        <li><a class:active={show === 'OVERVIEW'} on:click={() => setActiveTab('OVERVIEW')}>{M.OVERVIEW}</a></li>
        <li><a class:active={show === 'ENGAGEMENT'} on:click={() => setActiveTab('ENGAGEMENT')}>{M.ENGAGEMENT}</a></li>
      </ul>
    {/if}
  </div>
  {#if show === 'OVERVIEW'}
    <VideoAnalyticOverview bind:isLoading {id} {type} {chartData} />
  {:else if show === 'ENGAGEMENT'}
    <VideoEngagementGraph bind:isLoading videoId={id} />
  {/if}
</div>
